import api from './api';
import { Project, CreateProjectRequest, UpdateProjectRequest } from '../types';

export const projectService = {
  getAll: async (clientId?: number): Promise<Project[]> => {
    const response = await api.get('/projects', {
      params: clientId !== undefined ? { clientId } : {},
    });
    return response.data;
  },

  getById: async (id: number): Promise<Project> => {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  create: async (data: CreateProjectRequest): Promise<Project> => {
    const response = await api.post('/projects', data);
    return response.data;
  },

  update: async (id: number, data: UpdateProjectRequest): Promise<Project> => {
    const response = await api.put(`/projects/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/projects/${id}`);
  },
};

export default projectService;
